import React from 'react';

function DocLink({ href, label, icon }) {
  if (!href) return null;
  return (
    <a href={href} target="_blank" rel="noreferrer" title={label}>
      {icon ? (
        <button className="btn btn-outline-primary btn-sm">
          <i className={icon} />
        </button>
      ) : (
        label
      )}
    </a>
  );
}

function LinkList({ items, icon, divider }) {
  const nonEmpty = items.filter((item) => item.Link);
  if (nonEmpty.length === 0) return null;

  return (
    <div className="d-flex flex-column gap-1">
      {nonEmpty.map((item, idx) => (
        <React.Fragment key={idx}>
          {divider && idx > 0 && <hr className="my-1" />}
          <DocLink href={item.Link} label={item.Title || 'View'} icon={icon} />
        </React.Fragment>
      ))}
    </div>
  );
}

export default function MeetingRow({ date, meetings }) {
  const allNotices = meetings.map((m) => m.Notices).filter((n) => n?.Link);
  const allAgendas = meetings.flatMap((m) => m.Agendas ?? []);
  const allMaterials = meetings.flatMap((m) => m['Meeting Materials'] ?? []);
  const allMinutes = meetings.flatMap((m) => m.Minutes ?? []);

  return (
    <tr>
      <td className="fw-semibold text-nowrap">{date}</td>

      <td className="text-center">
        <div className="d-flex flex-column align-items-center gap-1">
          {allNotices.map((n, i) => (
            <DocLink
              key={i}
              href={n.Link}
              label="Notice"
              icon="fa-duotone fa-fw fa-solid fa-file-circle-exclamation"
            />
          ))}
        </div>
      </td>

      <td className="text-center">
        <LinkList
          items={allAgendas}
          icon="fa-duotone fa-fw fa-solid fa-memo-pad"
          divider={meetings.length > 1}
        />
      </td>

      <td>
        <LinkList items={allMaterials} divider={meetings.length > 1} />
      </td>

      <td>
        <LinkList items={allMinutes} divider={meetings.length > 1} />
      </td>
    </tr>
  );
}